/**
 * 接口地址管理(这是是config跨域定义的跨域接口,端口不同可以定义多个)
 */
const isDevelopment = process.env.NODE_ENV === "development";
const base = {
  api: isDevelopment? '/api': '',
  externalservice: isDevelopment ?'/externalservice':'',
  resourcecenter:isDevelopment ?'/resourcecenter':'',
  group:isDevelopment?'/group':'/group'
}

export default base
